import React from 'react'

import { AuthProvider } from './auth'
import { AdesaoConfigProvider } from './adesaoConfig'

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <AdesaoConfigProvider>{children}</AdesaoConfigProvider>
  </AuthProvider>
)
export default AppProvider
